import { Userprofile } from "src/app/_models/Userprofile";

export interface FormAdministratorState {
    admin: Userprofile | null;
    loading:boolean;
    error: any | null;
}

export const initialFormAdministratorState: FormAdministratorState = {
    admin: null,
    loading: false,
    error: null
}